import { QueryClient } from '@tanstack/react-query';

// In-memory only — NO persister (BUILD-SPEC §4.7): finance data must never be
// restored from disk on launch. `retry: false` so an expired session (401)
// redirects to login immediately instead of retrying the request.
//
// Mutations use `networkMode: 'always'` (PHASE3 §5.6): financial writes fired
// while offline must FAIL LOUDLY (the fetch rejects and the caller's onError
// surfaces a German toast) — TanStack's default 'online' mode would silently
// PAUSE the mutation and auto-replay the stale write on reconnect, which can
// overwrite the partner's newer categorization or duplicate a manual booking.
// `retry: false` so a failed write is never re-fired behind the user's back.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      retry: false,
    },
    mutations: {
      networkMode: 'always',
      retry: false,
    },
  },
});
